module.exports = __webpack_public_path__ + "static/media/pintura.82baa7fd.png";